import Vue from 'vue'
import router from './src/router'
import store from './src/store'
import Element from 'element-ui'
import 'normalize.css/normalize.css'
import './src/permission'
import './src/styles/index.scss' // global css
import './src/styles/element-variables.scss'
import messageLoading from './src/message-loading';
import Directives, { functionIndex } from './src/directives'
import LoadScript from '@yld/yun-utils-vue-plugin-load-script'
import App from './src/App.vue'

window.serverConfig = {}

// 自定义指令
Vue.use(Directives)

// 异步加载远程js
Vue.use(LoadScript)

Vue.use(Element, {
  size: 'small',
  zIndex: 3000
})

Vue.prototype.$ELEMENT = { size: 'small', zIndex: 3000 }
Vue.prototype.$messageLoading = messageLoading
class yldFramework extends Vue {
  constructor(props) {
    super(props)
    this.props = props
  }

  use(plugin, params) {
    Vue.use(plugin, params)
  }

  filter(key, value) {
    Vue.filter(key, value)
  }

  start() {
    window.serverConfig = this.props.serverConfig

    const serverConfig = this.props.serverConfig || {}
    Vue.prototype.$appId = serverConfig.appId // 应用Id

    Vue.config.productionTip = this.props.productionTip || false
    new Vue({
      el: '#app',
      router,
      store,
      render: h => h(App),
      ...this.props
    })
  }
}

export default yldFramework


export {
  router,
  store,
  functionIndex
}
